
import React from 'react';
import { Badge } from '@/components/ui/badge';

interface CourierActivityBadgeProps {
  repeatedPayments: number;
  multiPayments: number;
}

const CourierActivityBadge: React.FC<CourierActivityBadgeProps> = ({ 
  repeatedPayments, 
  multiPayments 
}) => {
  const getActivityInfo = (payments: number, multiPay: number) => {
    if (payments >= 5) {
      return { 
        label: 'Супер активный', 
        variant: 'success' as const,
        className: 'bg-emerald-600 hover:bg-emerald-700 text-white font-semibold shadow-md'
      };
    }
    if (payments >= 4) {
      return { 
        label: 'Высокая активность', 
        variant: 'success' as const,
        className: 'bg-green-500 hover:bg-green-600 text-white font-semibold shadow-md'
      };
    }
    if (payments >= 2) {
      return { 
        label: 'Хорошая активность', 
        variant: 'warning' as const,
        className: 'bg-yellow-500 hover:bg-yellow-600 text-white font-semibold shadow-md'
      };
    }
    if (payments >= 1) {
      return { 
        label: 'Средняя активность', 
        variant: 'warning' as const,
        className: 'bg-orange-500 hover:bg-orange-600 text-white font-semibold shadow-md'
      };
    }
    return { 
      label: 'Низкая активность', 
      variant: 'destructive' as const,
      className: 'bg-red-600 hover:bg-red-700 text-white font-semibold shadow-md'
    };
  };

  const activityInfo = getActivityInfo(repeatedPayments, multiPayments);

  return (
    <Badge 
      variant={activityInfo.variant}
      className={activityInfo.className}
    >
      {activityInfo.label}
    </Badge>
  );
};

export default CourierActivityBadge;
